import React from "react";

export default function BsFacebook() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 25"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#c)">
        <path
          d="M24 12.157C24 5.488 18.627.082 12 .082 5.37.084-.003 5.488-.003 12.158c0 6.026 4.39 11.021 10.125 11.927v-8.438H7.077v-3.489h3.048V9.497c0-3.025 1.793-4.696 4.533-4.696 1.314 0 2.687.235 2.687.235v2.97H15.83c-1.49 0-1.954.932-1.954 1.887v2.265h3.327l-.531 3.489h-2.798v8.438C19.611 23.177 24 18.183 24 12.157Z"
          fill="#currentColor"
        />
      </g>
      <defs>
        <clipPath id="c">
          <path fill="#fff" transform="translate(0 .082)" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
